export const envList = {
  flash_sale: {
    from: process.env.REACT_APP_FLASH_SALE_ALIAS_FROM,
    to: process.env.REACT_APP_FLASH_SALE_ALIAS_TO
  }
}